import React, { useState, useEffect, useRef } from "react";

import appStore from "../assets/images/app-store.png";
import playStore from "../assets/images/play-store.png";
import appStoreDark from "../assets/images/apple-dark.png";
import playStoreDark from "../assets/images/google-dark.png";

import sendButton from "../assets/images/send-button.png";
import attachmentPin from "../assets/images/attachment-pin.png";

import benzinga from "../assets/images/benzinga.png";
import khaleej from "../assets/images/khaleej.png";
import chronical from "../assets/images/chronical.png";
import benzingaDark from "../assets/images/brands-slider/bazinga-dark.png";
import khaleejDark from "../assets/images/brands-slider/khaleej-dark.png";
import chronicalDark from "../assets/images/brands-slider/chronicle-dark.png";
import stripe from "../assets/images/stripe.svg";
import question from "../assets/images/question.png";
import caseImg from "../assets/images/case.png";

import appScreenshot from "../assets/images/download-section/download-app1.png";
import appScreenshot2 from "../assets/images/download-section/download-app.png";

import businessPortal from "../assets/images/businessPortal.png";
import hireMultipleLawyers from "../assets/images/hireMultipleLawyers.png";
import lawyerVideoImg from "../assets/images/callMobile.png";

import contractor from "../assets/images/contractor.png";
import profileOne from "../assets/images/p1.png";
import profileTwo from "../assets/images/p2.png";
import corporate from "../assets/images/corporate.png";
import user from "../assets/images/user.png";
import firmLaw from "../assets/images/firm-law.png";
import forLawyer from "../assets/images/for-lawyer.png";

import { useNavigate, Link } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedText from "../components/AnimatedText";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "bootstrap/dist/css/bootstrap.min.css";

import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

// Import AOS
import AOS from "aos";
import "aos/dist/aos.css";
import Seo from "../components/Seo";
import axios from "axios";

const HomePage = () => {
  const navigate = useNavigate();
  const [scrollX, setScrollX] = useState(0);
  const [currentScreenshot, setCurrentScreenshot] = useState(0);
  const [audienceTab, setAudienceTab] = useState("consumers");
  const [faqTab, setFaqTab] = useState("general");
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [generalFaqApi, setGeneralFaqApi] = useState([]);
  const [lawyersFaqApi, setLawyersFaqApi] = useState([]);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-mode"));
    };

    checkDarkMode(); // Initial check

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          checkDarkMode();
        }
      });
    });

    observer.observe(document.body, { attributes: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await axios.get(
          `https://legalplatform.co/api/getFaqs?type=${faqTab}`
        );
        const faqs = res?.data?.data?.faqs || [];
        const mapped = faqs.map((f) => ({ q: f.question, a: f.answer }));
        if (faqTab === "general") {
          setGeneralFaqApi(mapped);
        } else if (faqTab === "lawyer") {
          setLawyersFaqApi(mapped);
        }
      } catch (e) {
        // console.error("Failed to fetch FAQs:", e);
      }
    };
    fetchFaqs();
  }, [faqTab]);



  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      setTimeout(() => {
        scroller.scrollTo(section, {
          duration: 500,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -100,
        });
      }, 300);
    }
  }, [location]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      offset: 100,
      delay: 100,
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Seo
        title="Online Legal Consultation & Lawyer Hire Services in India"
        description="Legal Platform offers online legal consultation, allowing businesses, law firms, and individuals in India to post legal issues and hire lawyers at affordable fees."
        canonicalPath={process.env.REACT_APP_BASE_PATH+'/' || "/"}
        image="/favicon.png"
      />
      <div className="img1 font-inter">
          <Header />
          {/* Find a Lawyer - Instant Video Call */}
          <div className="container-fluid lh-section mt-5">
            <div className="container">
              <div className="lh-top">
                {/* Left copy */}
                <div className="lh-left" data-aos="fade-up">
                  <h2 className="lh-title">
                    Find a Lawyer.<br />Get Help. <span>Now.</span>
                  </h2>
                  <p className="lh-sub">
                    Connect instantly with experienced lawyers through secure video call for your legal issues.
                  </p>
                  <div className="lh-btns">
                    {/* <Link to="/consultation-call" className="lh-btn-dark"> */}
                    <Link to="/" className="lh-btn-dark">
                      <i className="bi bi-bell-fill" /> SOS - Emergency Call
                    </Link>
                    {/* <Link to="/consultation-call" className="lh-btn-outline"> */}
                    <Link to="/" className="lh-btn-outline">
                      <i className="bi bi-camera-video" /> Video Call a Lawyer
                    </Link>
                  </div>
                  <div className="lh-trust">
                    <span><i className="bi bi-shield-check" /> Verified Lawyers</span>
                    <span><i className="bi bi-lock-fill" /> Secure &amp; Confidential</span>
                    <span><i className="bi bi-clock" /> 24/7 Available</span>
                  </div>
                </div>

                {/* Right phone + SOS */}
                <div className="lh-right" data-aos="fade-up" data-aos-delay="100">
                  <div className="w-100">
                    <img src={lawyerVideoImg} alt="Lawyer on a video call" className="w-100" />
                    {/* <div className="lh-call-top">
                      <div>
                        <div className="lh-call-name">Lawyer</div>
                        <div className="lh-call-time">00:24</div>
                      </div>
                      <span className="lh-call-flip"><i className="bi bi-arrow-repeat" /></span>
                    </div>
                    <img src={profileOne} alt="You" className="lh-video-self" />
                    <div className="lh-call-controls">
                      <button type="button" className="lh-ctrl"><i className="bi bi-mic-mute-fill" /></button>
                      <button type="button" className="lh-ctrl lh-ctrl-end"><i className="bi bi-telephone-fill" /></button>
                      <button type="button" className="lh-ctrl"><i className="bi bi-camera-video-fill" /></button>
                    </div> */}
                  </div>

                  <div className="lh-sos-card">
                    <div className="lh-sos-head"><i className="bi bi-exclamation-octagon-fill" /> SOS</div>
                    <div className="lh-sos-subhead">Emergency Call</div>
                    <div className="lh-sos-text">Connect instantly with a lawyer in emergency.</div>
                    {/* <Link to="/consultation-call" className="lh-sos-btn"> */}
                    <Link to="/" className="lh-sos-btn">
                      <i className="bi bi-telephone-fill" /> Call Now
                    </Link>
                  </div>
                </div>
              </div>

              {/* How it works */}
              <div className="lh-how">
                <div className="lh-how-title">How It Works</div>
                <div className="lh-how-grid">
                  <div className="lh-how-item">
                    <div className="lh-how-icon"><i className="bi bi-person-fill-check" /></div>
                    <div className="lh-how-body">
                      <div className="lh-how-name">1. Submit Your Issue</div>
                      <div className="lh-how-text">Tell us your legal issue in simple steps.</div>
                    </div>
                  </div>
                  <div className="lh-how-dash" />
                  <div className="lh-how-item">
                    <div className="lh-how-icon"><i className="bi bi-camera-video-fill" /></div>
                    <div className="lh-how-body">
                      <div className="lh-how-name">2. Connect on Video Call</div>
                      <div className="lh-how-text">We match you with the best lawyer and connect instantly.</div>
                    </div>
                  </div>
                  <div className="lh-how-dash" />
                  <div className="lh-how-item">
                    <div className="lh-how-icon"><i className="bi bi-bank" /></div>
                    <div className="lh-how-body">
                      <div className="lh-how-name">3. Get Legal Help</div>
                      <div className="lh-how-text">Discuss your issue on secure video call and get solutions.</div>
                    </div>
                  </div>
                </div>

                {/* Privacy bar */}
                <div className="lh-privacy">
                  <div className="lh-privacy-main">
                    <i className="bi bi-shield-lock-fill" />
                    <div>
                      <div className="lh-privacy-title">Your Privacy. Our Priority.</div>
                      <div className="lh-privacy-sub">All calls are secure, confidential and protected.</div>
                    </div>
                  </div>
                  <div className="lh-privacy-points">
                    <span><i className="bi bi-lock-fill" /> End-to-End Encrypted</span>
                    <span><i className="bi bi-patch-check-fill" /> 100% Confidential</span>
                    <span><i className="bi bi-database-fill-lock" /> Your Data is Safe with Us</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      

        {/* // Main Section */}
      <div className="header-banner" id="home">
        <div className="container position-relative">
          <div className="row g-4 align-items-stretch home-hero-row">
            <div className="col-lg-6">
              <div
                className="home-hero-main-card hp-hero-clickable"
                data-aos="fade-up"
                data-aos-delay="150"
                onClick={() => navigate("/post-your-legal-issue")}
              >
                <h1 className="home-hero-title text-center">
                  <AnimatedText text="Post Your" tag="span" />{" "}
                  <AnimatedText text="Legal" tag="span" />
                  <br className="d-none d-md-block" />
                  <span className="d-md-none">
                    <br />
                  </span>
                  <AnimatedText text="Issue Today" tag="span" />
                </h1>
                <div className="home-hero-text text-center">
                  <AnimatedText
                    text="Post your legal issue today & connect with trusted"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="professionals ready to help. Share your situation"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="securely, receive clear guidance, & explore practical"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="solutions quickly. From family matters to business"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="disputes, get timely answers, save time & money,"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="and move forward with confidence through an"
                    tag="span"
                  />
                  <span className="d-md-none"> </span>
                  <br className="d-none d-md-block" />
                  <AnimatedText
                    text="easy, confidential online platform today."
                    tag="span"
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <button
                    className="btn home-hero-main-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/post-your-legal-issue");
                    }}
                  >
                    Post Question
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-6 hire-a-lawyer-mob-res">
              <div className="d-flex flex-column gap-4 home-hero-side">
                <div
                  className="home-hero-card home-hero-card-light hp-hero-clickable text-center"
                  data-aos="fade-left"
                  data-aos-delay="200"
                  onClick={() => navigate("/hire-a-lawyer")}
                >
                  <h3 className="home-hero-card-title">
                    <AnimatedText text="Hire a Lawyer" />
                  </h3>
                  <div className="home-hero-card-text">
                    <AnimatedText
                      text="Hire trusted lawyers online, compare services, and get"
                      tag="span"
                    />{" "}
                    <AnimatedText
                      text="professional legal advice — all in one secure platform."
                      tag="span"
                    />
                  </div>
                  <button
                    className="btn btn-dark bg-black  btn-lg my-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/hire-a-lawyer");
                    }}
                  >
                    Hire a Lawyer
                  </button>
                </div>
                <div
                  className="home-hero-card home-hero-card-dark hp-hero-clickable"
                  data-aos="fade-left"
                  data-aos-delay="250"
                  onClick={() => navigate("/chat-with-lawyers")}
                >
                  <h3 className="home-hero-card-title home-hero-card-title-chat">
                    <AnimatedText text="Chat with Lawyers" />
                  </h3>
                  <div className="home-hero-card-text text-white">
                    <AnimatedText
                      text="Skip the high fees and long waiting times. Speak directly"
                      tag="span"
                    />{" "}
                    <AnimatedText
                      text="with experienced lawyers and resolve your legal matters"
                      tag="span"
                    />{" "}
                    <AnimatedText text="quickly and securely." tag="span" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Brand Slider */}
      <div
        className="container brands-slider"
        data-aos="fade-in"
        data-aos-duration="1200"
      >
        <div className="press-slider">
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            speed={2000}
            loop
            grabCursor
            slidesPerView={3}
            spaceBetween={40}
            breakpoints={{
              0: { slidesPerView: 2, spaceBetween: 24 },
              768: { slidesPerView: 3, spaceBetween: 32 },
              992: { slidesPerView: 3, spaceBetween: 40 },
            }}
          >
            <SwiperSlide>
              <img
                src={isDarkMode ? benzingaDark : benzinga}
                alt="Benzinga"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={isDarkMode ? khaleejDark : khaleej}
                alt="Khaleej Times"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={isDarkMode ? chronicalDark : chronical}
                alt="The Chronicle Journal"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={stripe}
                alt="Stripe"
                className="press-logo press-logo--stripe hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={isDarkMode ? benzingaDark : benzinga}
                alt="Benzinga"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={isDarkMode ? khaleejDark : khaleej}
                alt="Khaleej Times"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={isDarkMode ? chronicalDark : chronical}
                alt="The Chronicle Journal"
                className="press-logo hover-scale"
              />
            </SwiperSlide>
            <SwiperSlide>
              <img
                src={stripe}
                alt="Stripe"
                className="press-logo press-logo--stripe hover-scale"
              />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>

      {/*  What is Legal Platform  */}
      <div className="container who-for my-5" id="who-for">
        <div className="who-wrap" data-aos="fade-up">
          <h2
            className="text-white text-center pt-5 mb-2"
            data-aos="zoom-in"
            data-aos-delay="100"
          >
            <AnimatedText text="What is Legal Platform" />
          </h2>
          <div
            className="who-for-p text-center mb-4 mt-4"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <AnimatedText
              text="LegalPlatform connects users, businesses, and lawyers in one secure platform to post issues, hire legal experts, and manage matters effortlessly."
              tag="span"
            />
          </div>
          <div className="row g-3 g-md-4 mt-2">
            <div
              className="col-md-3 pe-0"
              data-aos="flip-left"
              data-aos-delay="300"
            >
              <div
                className="who-card hover-lift position-relative cursor-pointer"
                onClick={() => navigate("/for-corporate")}
                style={{ cursor: "pointer" }}
              >
                <h4>
                  <AnimatedText text="For" tag="span" /> <br className="br" />{" "}
                  <AnimatedText text="Corporate" tag="span" />
                </h4>
                <div>
                  <p>
                    <AnimatedText
                      text="Hire multiple lawyers, manage company legal matters, and oversee cases across departments from one centralized portal."
                      tag="span"
                    />
                  </p>
                </div>
                <div className="who-icon hover-rotate">
                  <img
                    src={corporate}
                    alt="Corporate"
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <div className="position-absolute bottom-0 end-0 p-3">
                  <i className="bi bi-arrow-up-right text-white fs-4"></i>
                </div>
              </div>
            </div>
            <div className="col-md-3" data-aos="flip-left" data-aos-delay="400">
              <div
                className="who-card h-100 hover-lift position-relative cursor-pointer"
                onClick={() => navigate("/for-users")}
                style={{ cursor: "pointer" }}
              >
                <h4>
                  <AnimatedText text="For" tag="span" /> <br className="br" />{" "}
                  <AnimatedText text="Users" tag="span" />
                </h4>
                <div>
                  <p>
                    <AnimatedText
                      text="Post your legal issue, hire a lawyer monthly or one-time, and connect directly for secure one-on-one guidance."
                      tag="span"
                    />
                  </p>
                </div>
                <div className="who-icon hover-rotate">
                  <img
                    src={user}
                    alt="Users"
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <div className="position-absolute bottom-0 end-0 p-3">
                  <i className="bi bi-arrow-up-right text-white fs-4"></i>
                </div>
              </div>
            </div>
            <div
              className="col-md-3 ps-0"
              data-aos="flip-left"
              data-aos-delay="500"
            >
              <div
                className="who-card h-100 hover-lift position-relative cursor-pointer"
                onClick={() => navigate("/for-law-firms")}
                style={{ cursor: "pointer" }}
              >
                <h4>
                  <AnimatedText text="For" tag="span" /> <br className="br" />{" "}
                  <AnimatedText text="Law Firms" tag="span" />
                </h4>
                <div>
                  <p>
                    <AnimatedText
                      text="Acquire new clients, manage legal work digitally, and streamline communication and billing in one secure platform."
                      tag="span"
                    />
                  </p>
                </div>
                <div className="who-icon hover-rotate">
                  <img
                    src={firmLaw}
                    alt="Law Firms"
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <div className="position-absolute bottom-0 end-0 p-3">
                  <i className="bi bi-arrow-up-right text-white fs-4"></i>
                </div>
              </div>
            </div>
            <div
              className="col-md-3 ps-0"
              data-aos="flip-left"
              data-aos-delay="600"
            >
              <div
                className="who-card h-100 hover-lift position-relative cursor-pointer"
                onClick={() => navigate("/for-lawyers")}
                style={{ cursor: "pointer" }}
              >
                <h4>
                  <AnimatedText text="For" tag="span" /> <br className="br" />
                  <AnimatedText text="Lawyers" tag="span" />
                </h4>
                <div>
                  <p>
                    <AnimatedText
                      text="Offer your services, respond to posted legal issues, send invoices in chat, and market your profile to scale to 6 figures."
                      tag="span"
                    />
                  </p>
                </div>
                <div className="who-icon hover-rotate">
                  <img
                    src={forLawyer}
                    alt="Lawyers"
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <div className="position-absolute bottom-0 end-0 p-3">
                  <i className="bi bi-arrow-up-right text-white fs-4"></i>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-3 pb-3">
                <button
                    className="btn bg-white btn-lg m-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate("/hire-a-lawyer");
                    }}
                  >
                  Hire a Lawyer
                </button>
                <button
                  className="btn bg-white  btn-lg m-3"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate("/lawyer-registration");
                  }}
                >
                  Lawyer Registration
                </button> 
          </div>
        </div>
      </div>

      {/* Features of AI Lawyer */}
      <div className="container features-legal" id="howitwork">
        <div className="text-center mb-3">
          <h2>
            <AnimatedText text="Features of Legal Platform" />
          </h2>
          <div className="mt-4 mb-5">
            <AnimatedText
              text="LegalPlatform connects users, businesses, and lawyers in one secure platform to post issues, hire legal experts, and manage matters effortlessly."
              tag="span"
            />
          </div>
        </div>
        <div className="row g-4 align-items-stretch">
          <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
            <div
              className="feature-tile feature-question text-center hover-lift"
              onClick={() => navigate("/post-your-legal-issue")}
              style={{ cursor: "pointer" }}
            >
              <h4 className="mt-1 fw-bold">
                <AnimatedText text="Post Question" />
              </h4>
              <img
                src={question}
                alt="Create a Question"
                className="feature-icon my-4 hover-scale"
              />
              <div className="feature-desc">
                <AnimatedText
                  text="Submit your legal issue and receive answers from"
                  tag="span"
                />
                <span className="d-md-none"> </span>
                <br className="d-none d-md-block" />
                <AnimatedText text="qualified lawyers." tag="span" />
              </div>
            </div>

            <div
              className="mt-3 case-card hover-lift"
              data-aos="fade-up"
              data-aos-delay="300"
              onClick={() => navigate("/hire-a-lawyer")}
              style={{ cursor: "pointer" }}
            >
              <div className="feature-tile feature-case text-center">
                <h4 className="mt-1 fw-bold text-white">
                  <AnimatedText text="Hire a Lawyer" />
                </h4>
                <img
                  src={caseImg}
                  alt="Create a Case"
                  className="feature-icon case-img my-4 hover-scale"
                />
                <div className="feature-desc text-white">
                  <AnimatedText
                    text="Connect with verified lawyers and get the legal"
                    tag="span"
                  />{" "}
                  <br />
                  <AnimatedText text="support you need." tag="span" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8" data-aos="fade-up" data-aos-delay="200">
            <div className="chat-card hover-lift">
          

              <div className="chat-bubbles">
                <div className="d-flex align-items-center justify-content-end mb-3">
                  <div
                    className="bubble dark align-self-end hp-dark-bubble d-flex flex-column align-items-end justify-content-between w-auto"
                    data-aos="fade-left"
                    data-aos-delay="350"
                  >
                    <span className="mb-1">
                      <AnimatedText
                        text="Hi, I need help reviewing a service agreement. Can you take a look?"
                        tag="span"
                      />
                    </span>
                    <span className="time time-right">02:12 PM</span>
                  </div>
                  <img
                    src={profileOne}
                    alt="User avatar"
                    className="chat-avatar ms-2"
                    data-aos="fade-left"
                    data-aos-delay="360"
                  />
                </div>

                <div className="d-flex align-items-center mb-3">
                  <img
                    src={profileTwo}
                    alt="Lawyer avatar"
                    className="chat-avatar me-2"
                    data-aos="fade-right"
                    data-aos-delay="420"
                  />
                  <div
                    className="bubble light d-flex flex-column align-items-start justify-content-between hp-light-bubble w-auto"
                    data-aos="fade-right"
                    data-aos-delay="420"
                  >
                    <span className="mb-1">
                      <AnimatedText text="Sure. Please upload the document and let me know what you’d like me to focus on." tag="span" />
                    </span>
                    <span className="time time-left">02:12 PM</span>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-end mb-3">
                  <div
                    className="bubble dark align-self-end hp-dark-bubble d-flex flex-column align-items-end justify-content-between w-auto"
                    data-aos="fade-left"
                    data-aos-delay="480"
                  >
                    <span className="mb-1">
                      <AnimatedText
                        text="Uploaded. I’m mainly concerned about the termination clause."
                        tag="span"
                      />
                    </span>
                    <span className="time time-right">02:13 PM</span>
                  </div>
                  <img
                    src={profileOne}
                    alt="User avatar"
                    className="chat-avatar ms-2"
                    data-aos="fade-left"
                    data-aos-delay="480"
                  />
                </div>

                <div className="d-flex align-items-center">
                  <img
                    src={profileTwo}
                    alt="Lawyer avatar"
                    className="chat-avatar me-2"
                    data-aos="fade-right"
                    data-aos-delay="540"
                  />
                  <div
                    className="bubble light d-flex flex-column align-items-start justify-content-between hp-light-bubble w-auto"
                    data-aos="fade-right"
                    data-aos-delay="540"
                  >
                    <span className="mb-1">
                      <AnimatedText text="Understood. I can review the contract and provide feedback. The consultation fee is USD 60. I’ll send the invoice now." tag="span" />
                    </span>
                    <span className="time time-left">02:13 PM</span>
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-end">
                  <div
                    className="bubble dark align-self-end hp-dark-bubble d-flex flex-column align-items-end justify-content-between w-auto"
                    data-aos="fade-left"
                    data-aos-delay="600"
                  >
                    <span className="mb-1">
                      <AnimatedText
                        text="Sounds good. Please proceed."
                        tag="span"
                      />
                    </span>
                    <span className="time time-right">02:14 PM</span>
                  </div>
                  <img
                    src={profileOne}
                    alt="User avatar"
                    className="chat-avatar ms-2"
                    data-aos="fade-left"
                    data-aos-delay="600"
                  />
                </div>
              </div>
              <div className="chat-footer">
                <div className="text-white hp-ask-ai-text">
                  <AnimatedText
                    text="Experience how easy it is to connect with lawyers on LegalPlatform. Direct chat, document sharing, and seamless communication — all in one streamlined interface."
                    tag="span"
                  />
                </div>
                <div className="input-wrap">
                  <input
                    type="text"
                    placeholder="Write a Messages..."
                    readOnly
                  />
                  <div className="input-actions">
                    <img
                      src={attachmentPin}
                      alt=""
                      className="hover-scale hp-attachment-icon"
                    />
                    <button className="send-btn hover-scale">
                      <img
                        src={sendButton}
                        alt=""
                        className="hp-send-button-icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-4 mt-2 business-portal-mob-res">
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
            <div
              className="multi-panel p-3 hover-lift hp-multi-panel-auto-height"
              onClick={() => navigate("/business-portal")}
              style={{ cursor: "pointer" }}
            >
              <h6 className="fw-semibold mb-3">
                <AnimatedText text="Business Portal" />
              </h6>
              <p>
                <AnimatedText text="Manage all your company's legal matters from one centralized dashboard. Post legal issues, track ongoing cases, onboard team members, and communicate with lawyers securely — all in one structured environment designed for businesses." />
              </p>
              <div className="row g-3 mt-1 px-3 pb-4">
                <div className="col-12 d-flex justify-content-center align-items-center">
                  <img
                    src={businessPortal}
                    alt=""
                    className="hover-scale hp-business-portal-image"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div
              className="multi-panel p-3 hover-lift hp-multi-panel-auto-height"
              onClick={() => navigate("/hire-multiple-lawyers")}
              style={{ cursor: "pointer" }}
            >
              <h6 className="fw-semibold mb-3">
                <AnimatedText text="Hire Multiple Lawyers for Your Business" />
              </h6>
              <p className="text-muted">
                <AnimatedText text="Access and retain multiple lawyers across different practice areas based on your company’s needs. Compare services, manage subscriptions, review invoices, and build a scalable legal support system tailored to your organization." />
              </p>
              <div className="row g-3 mt-1 px-3 pb-4">
                <div className="col-12 d-flex justify-content-center align-items-center">
                  <img
                    src={hireMultipleLawyers}
                    alt=""
                    className="hover-scale hp-hire-lawyers-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
      {/* FAQ's */}
      <div className="container-fluid faq-bgImg mt-5">
        <div className="container my-5" id="faq">
          <div className="faq-wrap p-3 p-md-4" data-aos="fade-up">
            <div className="text-center mb-3">
              <h2>
                <AnimatedText text="Have a question?" />
              </h2>
              <div className="text-muted mb-5">
                <AnimatedText text="Browse through our frequently asked topics." />
              </div>
            </div>
            <div
              className="d-flex justify-content-center mb-4"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="faq-tabs">
                <button
                  className={`faq-tab ${faqTab === "general" ? "active" : ""}`}
                  onClick={() => setFaqTab("general")}
                >
                  General
                </button>
                <button
                  className={`faq-tab ${faqTab === "lawyer" ? "active" : ""}`}
                  onClick={() => setFaqTab("lawyer")}
                >
                  Lawyers
                </button>
              </div>
            </div>
            <div className="accordion accordion-flush" id="faqAccordion">
                {faqTab === "general"
                  ? generalFaqApi.map((item, idx) => (
                      <div
                        className="accordion-item faq-card hover-lift"
                        key={`general-${idx}`}
                        data-aos="fade-up"
                        data-aos-delay={idx * 50}
                      >
                        <h2
                          className="accordion-header"
                          id={`flush-heading-general-${idx}`}
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#flush-collapse-general-${idx}`}
                            aria-expanded="false"
                            aria-controls={`flush-collapse-general-${idx}`}
                          >
                            <AnimatedText text={item.q} />
                          </button>
                        </h2>
                        <div
                          id={`flush-collapse-general-${idx}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`flush-heading-general-${idx}`}
                          data-bs-parent="#faqAccordion"
                        >
                          <div className="accordion-body">{item.a}</div>
                        </div>
                      </div>
                    ))
                  : lawyersFaqApi.map((item, idx) => (
                      <div
                        className="accordion-item faq-card hover-lift"
                        key={`lawyers-${idx}`}
                        data-aos="fade-up"
                        data-aos-delay={idx * 50}
                      >
                        <h2
                          className="accordion-header"
                          id={`flush-heading-lawyers-${idx}`}
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#flush-collapse-lawyers-${idx}`}
                            aria-expanded="false"
                            aria-controls={`flush-collapse-lawyers-${idx}`}
                          >
                            <AnimatedText text={item.q} />
                          </button>
                        </h2>
                        <div
                          id={`flush-collapse-lawyers-${idx}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`flush-heading-lawyers-${idx}`}
                          data-bs-parent="#faqAccordion"
                        >
                          <div className="accordion-body">{item.a}</div>
                        </div>
                      </div>
                    ))}
              </div>
          </div>
        </div>
      </div>

      <div className="container my-5" id="download-app">
        <div
          className="mobile-app-banner p-3 p-md-4 hover-lift"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="row align-items-center g-4 h-100">
            <div
              className="col-md-6 d-none d-md-block"
              data-aos="fade-right"
              data-aos-delay="150"
            >
              <div className="download-phones">
                <img
                  src={appScreenshot}
                  alt="App preview 1"
                  className="phone-1"
                />
                <img
                  src={appScreenshot2}
                  alt="App preview 2"
                  className="phone-2"
                />
              </div>
            </div>
            <div className="col-md-6 h-100 d-flex flex-column justify-content-center align-items-center">
              <div className="text-white">
                <h2 className="mb-2 download-app-title text-center">
                  <AnimatedText text="Start your legal" /> <br />
                  <AnimatedText text="journey today" baseIndex={16} />
                </h2>
                <div className="download-app-desc text-center">
                  <AnimatedText
                    text="Access trusted legal professionals, streamline"
                    tag="span"
                  />{" "}
                  <br className="br" />
                  <AnimatedText
                    text="communication, and handle your legal needs"
                    tag="span"
                  />{" "}
                  <br className="br" />
                  <AnimatedText
                    text="with confidence — anytime, anywhere."
                    tag="span"
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                  {/* Light Mode Images */}
                  <a
                    href="https://apps.apple.com/us/app/legal-platform/id6475202489"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download on the App Store"
                  >
                    <img
                      src={appStore}
                      alt="App Store"
                      className="store-badge store-badge-light hover-scale"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.app.legalplatform&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get it on Google Play"
                  >
                    <img
                      src={playStore}
                      alt="Google Play"
                      className="store-badge store-badge-light hover-scale"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    />
                  </a>
                  {/* Dark Mode Images */}
                  <a
                    href="https://apps.apple.com/us/app/legal-platform/id6475202489"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download on the App Store"
                  >
                    <img
                      src={appStoreDark}
                      alt="App Store"
                      className="store-badge store-badge-dark hover-scale"
                      data-aos="fade-up"
                      data-aos-delay="200"
                    />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.app.legalplatform&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get it on Google Play"
                  >
                    <img
                      src={playStoreDark}
                      alt="Google Play"
                      className="store-badge store-badge-dark hover-scale"
                      data-aos="fade-up"
                      data-aos-delay="300"
                    />
                  </a>
                </div>

                {/* Mobile-only images shown after buttons */}
                <div className="d-block d-md-none mt-5 text-center">
                  <div className="download-phones position-relative d-inline-block">
                    <img
                      src={appScreenshot2}
                      alt="App preview 2"
                      className="phone-2"
                      style={{
                        transform: "none",
                        position: "relative",
                        left: "auto",
                        top: "auto",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}

      <Footer />
    </>
  );
};

export default HomePage;
